import React, { forwardRef } from 'react'
import { ActionIcon, type ActionIconProps } from '@mantine/core'

export type AppIconButtonProps = ActionIconProps

/** Forwards ref so Mantine Menu/Popover targets can position dropdowns correctly. */
const AppIconButton = forwardRef<HTMLButtonElement, AppIconButtonProps>(function AppIconButton (
  props,
  ref
) {
  return <ActionIcon ref={ref} radius="md" {...props} />
})

AppIconButton.displayName = 'AppIconButton'

export default AppIconButton
